import React, {useContext, useEffect} from "react";
import { AuthContext } from './context/AuthContext';
import './App.css';
import TopMenu from "./components/Topmenu";
import {Switch, Route, Redirect} from "react-router-dom";
import FindYourHero from "./pages/findyourhero/FindYourHero";
import Register from "./pages/register/Register";
import TopTen from "./pages/topten/TopTen";
import AboutUs from "./pages/aboutus/AboutUs";
import Home from "./pages/home/Home";
import Series from "./pages/series/Series";
import SearchHero from "./pages/searchHero/SearchHero";
import Login from "./pages/login/Login";
import Profile from './components/profile/Profile';

function App() {
    const { isAuth } = useContext(AuthContext);

    useEffect(() => {
        document.title = "Superhelden Site";
    }, []);

    return (
   <>
       <TopMenu/>
       <Switch>
           <Route  path="/top-ten">
               <TopTen />
           </Route>
           <Route path="/find-your-hero/:blogId">
               <FindYourHero />
           </Route>
           <Route  path="/search-your-hero">
               <SearchHero />
           </Route>

           <Route path="/register">
               <Register />
           </Route>
           <Route path="/login">
               <Login />
           </Route>
           <Route path="/about-us">
               <AboutUs />
           </Route>
           <Route  path="/series">
               <Series />
               </Route>
           <Route path="/profile">
               {isAuth ? <Profile /> : <Redirect to="/" />}
           </Route>
           <Route exact path="/">
               <Home />
           </Route>
       </Switch>
   </>
  );
}

export default App;
